/**
 * Creates an invisible input that can be used to shift page focus using the final-form-focus decorator
 * @see: https://github.com/final-form/final-form-focus
 */
import React from 'react';
import PropTypes from 'prop-types';
var FormFocus = function FormFocus(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/React.createElement("input", {
    name: name,
    style: {
      appearance: 'none',
      border: 'none',
      outline: 'none',
      margin: 0,
      padding: 0,
      // needs to be 'visisble for iOS to scroll to..
      width: '100%',
      height: 1,
      marginBottom: -1,
      opacity: 0.1,
      // prevent zoom...
      fontSize: 20
    }
    // prevent keyboard
    ,
    readOnly: true
  });
};
FormFocus.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired
} : {};
export default FormFocus;